import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-FormCopy',
	isLoading: 'c-FormCopy--IsLoading',
	content: 'c-FormCopy__Content',
	menu: 'c-FormCopy__Menu',
};

export const Style = {
	[CSS.container]: {
		width: '600px',
	},
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.content]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-around',
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
};
